<template>
  <a-list
    itemLayout="horizontal"
    :dataSource="list"
  >
    <a-list-item slot="renderItem" slot-scope="item, index" :key="index">
      <a-list-item-meta>
        <a slot="title">{{ item.title }}</a>
        <span slot="description">
          <span class="security-list-description">{{ item.description }}</span>
          <span v-if="item.value"> : </span>
          <span class="security-list-value">{{ item.value }}</span>
        </span>
      </a-list-item-meta>
      <template v-if="item.actions">
        <a slot="actions" @click="item.actions.callback">{{ item.actions.title }}</a>
      </template>
    </a-list-item>

    <password-update-form :visible.sync="visible.updatePassword" @onUpdated="onPasswordUpdated"/>
  </a-list>
</template>

<script>
import PasswordUpdateForm from './form/PasswordUpdateForm'
import { blur, getStrength } from '@/utils/util'
import { mapGetters } from 'vuex'

export default {
  components: { PasswordUpdateForm },

  data () {
    return {
      loading: false,
      visible: {
        updatePassword: false
      },
      pwdStrength: '待定'
    }
  },

  computed: {
    list () {
      console.log(this.userInfo().mobile)
      return [{
        title: '账户密码',
        description: '当前密码强度',
        value: this.pwdStrength,
        actions: { title: '修改', callback: this.showPasswordForm }
      },
      {
        title: '密保手机',
        description: '已绑定手机',
        value: blur(this.userInfo().mobile, 3, 7),
        actions: { title: '修改', callback: this.showMobileForm }
      }]
    }
  },

  methods: {
    ...mapGetters(['userInfo']),

    showPasswordForm () {
      this.visible.updatePassword = true
    },

    showMobileForm () {
      this.$message.warn('抱歉，该功能暂未开放')
    },

    onPasswordUpdated (password) {
      this.pwdStrength = getStrength(password)
    }
  }
}
</script>

<style scoped>

</style>
